import "./App.css";
import LoadingPage from "./pages/utils/loading.page";
import Router from "./routes/router";
import { getAccountProxy, useAccountSnapshot } from "./stores/account.store";

const accountProxy = getAccountProxy();
accountProxy.loadUser();

function App() {
  const userSnapshot = useAccountSnapshot();
  if (userSnapshot.isLoading) return <LoadingPage />;

  return <Router />;
}

export default App;
